import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { Container, Row, Col } from "react-bootstrap";
import PageHeadingNew from "../../common-components/custom-comps/PageHeadingNew";
import BCAWebhook from "./BCAWebhook";
import { FORMATTED_TODAY_DATE_YYYYMMDD } from "../../common-data/Converts";
import CmnFilters from "../../lead-management/common/CmnFilters";
import {
  fetcBCAPendingNotificationsData,
  fetchLiveBCAStatsData,
} from "../../../redux/live-reducers/liveSlice";
import PendingBCALogs from "./PendingBCALogs";
import LiveResolutionStat from "../live-trials/LiveResolutionStat";
import { getCommaSeparatedValues } from "../../pt-trials/member-report/MemberReportMocks";

const LiveBCAPendingLogsStructure = ({ userInfoData }) => {
  const dispatch = useDispatch();

  const isAdmin = userInfoData?.account_type === "admin";
  const isGym = userInfoData?.account_type === "gym";

  const isManagerRole = [
    "cluster_manager",
    "fitness_manager",
    "sales_manager",
    "club_manager",
  ].includes(userInfoData?.account_type);

  const [isPage, setIsPage] = useState(0);
  const [pageLimit, setPageLimit] = useState(10);
  const iniAllFilter = {
    selectedGym:
      !isAdmin && !isManagerRole
        ? {
            label: isGym ? userInfoData?.name : userInfoData?.gym_name || "",
            value:
              userInfoData?.gym_id ||
              userInfoData?.user_id ||
              userInfoData?.uid ||
              "",
          }
        : "",
    leadAddDateFrom: FORMATTED_TODAY_DATE_YYYYMMDD,
    leadAddDateTo: FORMATTED_TODAY_DATE_YYYYMMDD,
    selAddedby: "",
    isActive: "",
    searchString: "",
    showFiltersDropdown: false,
    selectedRenewalStatus: "",
    selectedStuckStatus: "",
    selectedCheckinTime: [],
    selectedThreeDayTrialStatus: "",
    threeDayDoneDateFrom: "",
    threeDayDoneDateTo: "",
  };
  const [allFilters, setAllFilters] = useState(iniAllFilter);
  const iniFilters = {
    page: isPage + 1,
    limit: pageLimit || 10,
    gym_id: allFilters.selectedGym?.value || "",
    resolved_by: allFilters.selAddedby?.value || "",
    is_resolved: allFilters.isActive?.value || "",
    is_renewal_filter: allFilters.selectedRenewalStatus?.value || "",
    three_day_done_count: allFilters.selectedThreeDayTrialStatus?.value || "",
    is_stuck: allFilters.selectedStuckStatus?.value || "",
    checkin_time_filter: getCommaSeparatedValues(
      allFilters.selectedCheckinTime
    ),
    date_from: allFilters.leadAddDateFrom || "",
    date_to: allFilters.leadAddDateTo || "",
    three_day_done_from: allFilters.threeDayDoneDateFrom || "",
    three_day_done_to: allFilters.threeDayDoneDateTo || "",
  };
  const [filters, setFilters] = useState(iniFilters);
  const [searchFilterApplied, setSearchFilterApplied] = useState(false);

  const iniDatas = {
    pagination: [],
    allData: [],
  };
  const [allDatas, setAllDatas] = useState(iniDatas);

  const onResetFilters = () => {
    setAllFilters(iniAllFilter);
    setFilters(iniFilters);
    setSearchFilterApplied(false);
  };

  const onClickSearch = () => {
    setIsPage(0);

    if (allFilters.searchString) {
      setSearchFilterApplied(true);
      setFilters((prevs) => ({ ...prevs, search: allFilters.searchString }));
    }
  };

  function getLiveResolutionStats(filters) {
    const { page, limit, ...rest } = filters;

    dispatch(
      fetchLiveBCAStatsData({
        filters: { ...rest },
        token: userInfoData?.token,
      })
    );
  }

  function getPendingBCALogs(filters) {
    dispatch(
      fetcBCAPendingNotificationsData({
        filters: filters,
        token: userInfoData?.token,
      })
    );
  }

  useEffect(() => {
    getLiveResolutionStats(filters);
  }, [
    filters.gym_id,
    filters.resolved_by,
    filters.date_from,
    filters.date_to,
    filters.is_resolved,
  ]);

  useEffect(() => {
    getPendingBCALogs(filters);
  }, [filters]);

  useEffect(() => {
    setFilters((prevs) => ({
      ...prevs,
      page: isPage + 1,
      limit: pageLimit || 10,
      gym_id: allFilters.selectedGym?.value || "",
      resolved_by: allFilters.selAddedby?.value || "",
      is_resolved: allFilters.isActive?.value || "",
      is_renewal_filter: allFilters.selectedRenewalStatus?.value || "",
      three_day_done_count: allFilters.selectedThreeDayTrialStatus?.value || "",
      is_stuck: allFilters.selectedStuckStatus?.value || "",
      checkin_time_filter: getCommaSeparatedValues(
        allFilters.selectedCheckinTime
      ),
      date_from: allFilters.leadAddDateFrom || "",
      date_to: allFilters.leadAddDateTo || "",
      three_day_done_from: allFilters.threeDayDoneDateFrom || "",
      three_day_done_to: allFilters.threeDayDoneDateTo || "",
    }));
  }, [
    isPage,
    pageLimit,
    allFilters.selectedGym,
    allFilters.leadAddDateFrom,
    allFilters.leadAddDateTo,
    allFilters.selAddedby,
    allFilters.isActive,
    allFilters.threeDayDoneDateFrom,
    allFilters.threeDayDoneDateTo,
    allFilters.selectedRenewalStatus,
    allFilters.selectedThreeDayTrialStatus,
    allFilters.selectedStuckStatus,
    allFilters.selectedCheckinTime,
  ]);

  useEffect(() => {
    if (allFilters.searchString?.length === 0) {
      setSearchFilterApplied(false);
      setFilters((prevs) => ({ ...prevs, search: "" }));
      setIsPage(0);
    }
  }, [allFilters.searchString]);

  return (
    <Container className="bg-cloud-k px-50px" fluid>
      <Row>
        <Col>
          <BCAWebhook userInfoData={userInfoData} setAllDatas={setAllDatas} />
        </Col>
      </Row>

      <Row>
        <Col>
          <PageHeadingNew
            heading="Live BCA Pending Logs"
            subheading="Real-time BCA Pending Logs Monitoring and Management"
            onReload={() => {
              getLiveResolutionStats(filters);
              getPendingBCALogs(filters);
            }}
          />
        </Col>
      </Row>

      <Row>
        <Col>
          <CmnFilters
            from="live-bca-logs-notifications"
            userInfoData={userInfoData}
            filters={allFilters}
            setFilters={setAllFilters}
            onClickReset={onResetFilters}
            onClickSearch={onClickSearch}
            searchFilterApplied={searchFilterApplied}
          />
        </Col>
      </Row>

      {allFilters.showFiltersDropdown && (
        <Row>
          <Col>
            <LiveResolutionStat from="bca" />
          </Col>
        </Row>
      )}

      <Row>
        <Col>
          <PendingBCALogs
            isPage={isPage}
            setIsPage={setIsPage}
            pageLimit={pageLimit}
            setPageLimit={setPageLimit}
            allDatas={allDatas}
            setAllDatas={setAllDatas}
            userInfoData={userInfoData}
            callFunction={() => {
              getLiveResolutionStats(filters);
              getPendingBCALogs(filters);
            }}
          />
        </Col>
      </Row>
    </Container>
  );
};

export default LiveBCAPendingLogsStructure;
